import React from "react";
import { AbstractTooltip as Tooltip } from "../../ToolTip/ToolTip";
import { ObjectActionsType, useObjectsDispatch, useObjectsState } from "../../../contexts/ObjectsProvider";
import { ReactComponent as CopyIcon } from "../../../assets/Copy-White.svg";

const CopyButton = ({ readonly }: { readonly?: boolean }) => {
  const { selectedObjects } = useObjectsState();
  const objectsDispatch = useObjectsDispatch();

  const disabledClassName = readonly ? "pointer-events-none" : "";
  const disabledStyle = readonly ? { backgroundColor: "var(--disabled-color)" } : {};

  return (
    <button
      className={`wysiwyg-toolbar-btn ${disabledClassName}`}
      style={disabledStyle}
      id="copy"
      onClick={() => {
        objectsDispatch({
          type: ObjectActionsType.COPY_OBJECTS,
        });
      }}
      data-tooltip-id="Copy"
    >
      <Tooltip id="Copy" />
      <CopyIcon />
      {/* <span className="icon-copy"></span> */}
    </button>
  );
};

export default CopyButton;
